import {
    SET_ADD_NEW_PARTNER_OPENED,
    SET_ACTIVE_PARTNER,
    SET_PARTNERS,
    SET_IS_HISTORY_OPENED,
    IActivePartner,
    IPartner,
    SetPartners,
    SetAddNewPartnerOpened,
    SetActivePartner,
    SetIsHistoryOpened,
} from "./partners-types";

export const setAddNewPartner = (
    isAddNewPartnerOpened: boolean
): SetAddNewPartnerOpened => ({
    type: SET_ADD_NEW_PARTNER_OPENED,
    isAddNewPartnerOpened,
});

export const setActivePartner = (
    activePartner: IActivePartner
): SetActivePartner => ({
    type: SET_ACTIVE_PARTNER,
    activePartner,
});

export const setPartners = (partners: IPartner[]): SetPartners => ({
    type: SET_PARTNERS,
    partners,
});

export const setIsPartnerHistoryOpened = (
    isHistoryOpened: boolean
): SetIsHistoryOpened => ({
    type: SET_IS_HISTORY_OPENED,
    isHistoryOpened: isHistoryOpened,
});
